<div class="main"><Header v-if="showHeader"></Header><router-view></router-view><Footer></Footer></div>